import React, { Component } from 'react'

const fromString = (val) => new Date(Date.parse(val))

function dateToString(date) {
  var d = new Date(date),
    month = '' + (d.getMonth() + 1),
    day = '' + d.getDate(),
    year = d.getFullYear()

  if (month.length < 2) month = '0' + month
  if (day.length < 2) day = '0' + day

  return [year, month, day].join('-')
}

export class DatePicker extends Component {
  onUpdate(ev) {
    if (ev === '' || ev === null) {
      this.props.onUpdate({ target: { value: null } })
    } else {
      let [Y, m, d] = ev.split('-')
      // need to add 2 hours for UTC
      let date = new Date(Y, m - 1, d, 2, 0)
      this.props.onUpdate({ target: { value: date.toJSON() } })
    }
  }

  render() {
    return (
      <div>
        <label className="label">{this.props.name}</label>
        <input
          type="date"
          disabled={this.props.disabled}
          className="input date-field"
          defaultValue={
            this.props.value ? dateToString(fromString(this.props.value)) : ''
          }
          onChange={(e) => this.onUpdate(e.target.value)}
          id={this.id}
          required={this.props.required || false}
        />
      </div>
    )
  }
}

export function genYears() {
  const start = 2006
  const current = new Date().getFullYear()
  return Array(current - start + 1)
    .fill()
    .map((_, i) => start + i)
}
